module.exports = __webpack_public_path__ + "img/recurring-blue.fe3c1e4b.svg";